export const lineOptions = {
  chart: {
    type: 'line',
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  markers: {
    size: 5,
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
  },
  xaxis: {
    categories: [""],
    offsetX: -35,
    labels: {
      formatter: (val: string): string => {
        if (val === "8時" || val === "8 am" || val === "1時" || val === "1 am") {
          return " "
        }
        return val
      },
    },
  },
  tooltip: {
    x: {
      formatter: (index: number): string => `${lineOptions.xaxis.categories[index - 1]} ~ ${lineOptions.xaxis.categories[index]}`,
    },
  },
  legend: {
    position: 'top',
  },
}

export default lineOptions
